module.exports = __webpack_public_path__ + "fonts/Proxima Nova Bold.62d4d7d3.otf";